export const success = 'success';
export const error = 'error';
export const pre = 'pre';